<template>
  <div>
    <el-row>
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;margin-top:30px"
        class="demo-ruleForm">
        <el-col :span="5">
          <el-form-item label="国家" prop="countryMark">
            <el-select v-model="ruleForm.countryMark" clearable placeholder="请选择国家" filterable>
              <el-option v-for="item in countryList" :key="item.id" :label="item.countryName" :value="item.countryCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="退仓状态" prop="exitStatus">
            <el-select v-model="ruleForm.exitStatus" clearable placeholder="请选择退仓状态">
              <el-option label="退仓" value="退仓"></el-option>
              <el-option label="退仓上架" value="退仓上架"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="重派状态" prop="status">
            <el-select v-model="ruleForm.status" clearable placeholder="请选择重派状态">
              <el-option label="未处理" value="0"></el-option>
              <el-option label="重派中" value="1"></el-option>
              <el-option label="重派完成" value="2"></el-option>
              <el-option label="销毁" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="渠道" prop="channelType">
            <el-select v-model="ruleForm.channelType" clearable filterable>
              <el-option v-for="item in listLogistics" :key="item.id" :label="item.itemTypeName"
                :value="item.itemTypeId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="时间搜索类型" prop="timeType">
            <el-select v-model="ruleForm.timeType" placeholder="请选择时间搜索类型">
              <el-option label="创建时间" value="1"></el-option>
              <el-option label="重派时间" value="2"></el-option>
              <el-option label="销毁时间" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="开始日期" prop="startTime">
            <el-date-picker v-model="ruleForm.startTime" @change="startTime" align="right" type="date"
              placeholder="选择开始日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="结束日期" prop="endTime">
            <el-date-picker v-model="ruleForm.endTime" @change="endTime" align="right" type="date" placeholder="选择结束日期"
              format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="核对详情" prop="purchaseModel">
            <el-input v-model.trim="ruleForm.purchaseModel" placeholder="请输入核对详情" style="width: 58%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="多个原转单号" prop="inputList">
            <el-input v-model.trim="ruleForm.inputList" placeholder="请输入多个原转单号，空格分开" style="width: 80%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="searchStr" style="margin-left: 0px;">
            <el-input v-model.trim="ruleForm.searchStr" placeholder="退件条码、原转号、渠道ID" style="width: 65%;"></el-input>
            <el-button type="primary" @click="search2" style="margin-left:20px;">搜索</el-button>
            <el-button type="primary" @click="resetFprm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <div class="table-body">
      <div class="table-batch">
        <el-button type="danger" @click="destroyCodReturn" style="float: left; margin-top: 5px;" :disabled="ids.length == 0">批量销毁</el-button>
        <el-button type="primary" @click="dialogVisible = true" style="margin-right: 10px;">
          批量导入退件
        </el-button>
        <el-popover placement="left" trigger="click">
          <div>
            <div style="color: red;margin-bottom: -8px;">未处理的,未销毁的,且未匹配的cod退件</div>
            <br />
            <el-date-picker v-model="exportTime" type="daterange" size="small" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
            <el-button type="primary" @click="handleExport" style="float: right; margin-left: 10px;">
              确定
            </el-button>
          </div>
          <el-button type="primary" slot="reference">
            导出COD退件
          </el-button>
        </el-popover>
      </div>
      <div class="table-list">
        <el-button @click="clearFilter">清除所有过滤器</el-button>
        <el-table ref="filterTable" width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }"
          v-loading="loading"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55"
            align="center">
          </el-table-column>
          <el-table-column width="80" prop="id" sort-by="inventoryNumber" label="退仓ID" align="center" />

          <el-table-column align="left" label="商品信息" width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.orderInfo && scope.row.orderInfo.orderItems">
                <div class="details" v-for="(item, index) in scope.row.orderInfo.orderItems" :key="index">
                  <div class="details_left">
                    <el-popover trigger="hover" placement="right" prop="orderItems.imageUrl" v-if="item.imageUrl">
                      <img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt
                        style="width:500px;height:500px;" />
                      <div class="scope_img" slot="reference">
                        <img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt />
                      </div>
                    </el-popover>
                    <el-button type="text" size="mini" v-else @click="getOriginalImg(item)" style="padding: 0;">查看原图
                    </el-button>
                  </div>
                  <div class="details_right">
                    <div style="width: 100%;" v-if="item.title !== null" class="textlang" :title="item.title">
                      <strong style="color:black">商品简称:</strong> {{ item.title }}
                    </div>
                    <div style="width: 100%;" v-show="item.systemSku">
                      <strong style="color:black">系统SKU:</strong> {{ item.systemSku }}
                    </div>
                    <div style="width: 100%;">
                      <strong style="color:black">SKU:</strong> {{ item.sellerSKU }}
                    </div>
                    <div style="width: 100%;" v-show="item.productSku">
                      <strong style="color:black">产品SKU:</strong> {{ item.productSku }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="productDescription" label="订单信息" align="left" width="220">
            <template slot-scope="scope">
              <div class="details">
                <div class="details_right" style="width: 100%">
                  <div style="width: 100%;" v-if="scope.row.orderInfo">
                    <strong style="color:black">原订单号:</strong> {{ scope.row.orderInfo.amazonOrderId }}
                  </div>
                  <div style="width: 100%;" v-if="scope.row.orderInfo">
                    <strong style="color:black">原订单ID:</strong> {{ scope.row.orderInfo.id }}
                  </div>
                  <div style="width: 100%;">
                    <strong style="color:black">退件条码:</strong> {{ scope.row.returnBarcode }}
                  </div>
                  <div style="width: 100%;">
                    <strong style="color:black">原转单号:</strong> {{ scope.row.oldConveyNumber }}
                  </div>
                  <div style="width: 100%;">
                    <strong style="color:black">渠道ID:</strong> {{ scope.row.orderChannelId }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="采购需求" align="center" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.orderInfo && scope.row.orderInfo.purchaseDemands">
                <div class="details" v-for="(item, index) in scope.row.orderInfo.purchaseDemands" :key="index">
                  <div class="details_right" style="width: 100%">
                    <div style="width: 100%;">
                      <pre style="white-space: pre-wrap;">{{ item.purchaseDemand }}</pre>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="productSimpleName" label="核对详情" align="center" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.orderInfo">
                <div class="details" style="width: 100%; text-align: center;display: block;"
                  v-for="(item, index) in scope.row.orderInfo.purchaseDemands" :key="index + 'q'">
                  <div v-for="(ele, i) in item.purchaseItems" :key="i + 'w'" style="width: 100%; text-align: center;">
                    <div class="details_right" style="width: 100%; text-align: center;">
                      <div style="width: 100%;">
                        {{ ele.purchaseModel }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="countryName" label="国家" align="center" width="80"></el-table-column>
          <el-table-column prop="destroyTime" label="销毁时间" align="center"></el-table-column>
          <el-table-column prop="status" label="重派状态" align="center" width="100">
            <template slot-scope="scope">
              <el-tag :type="statusType[Number(scope.row.status)]">{{ statusFont[Number(scope.row.status)] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="exitStatus" label="退仓状态" width="100" align="center"></el-table-column>
          <el-table-column prop="reassignFrequency" label="重派次数" width="100" align="center" 
          :filters="[{ text: '0', value: 0 }, { text: '1', value: 1 }, { text: '2', value: 2 }, { text: '3', value: 3 }, { text: '4', value: 4 }, { text: '5', value: 5 }, { text: '6', value: 6 }, { text: '7', value: 7 }, { text: '8', value: 8 }]"
          :filter-method="filterHandler"></el-table-column>
          <el-table-column prop="reassignTime" label="重派时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="primary" v-if="scope.row.orderInfo" @click="showDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="page">
      <el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :current-page="currentPage" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <Addinventory ref="Addinventory" @Addinventory="search" />
    <buildbyoneself ref="buildbyoneself" @Editinventory="search" />

    <el-dialog title="导入COD退件" :visible.sync="dialogVisible" width="30%" @close="handleUploadExcelDialogClose"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <el-row :gutter="20" style="padding-left: 20px;margin-bottom: 20px">
        渠道：
        <el-select v-model="logistics" filterable>
          <el-option v-for="item in listLogistics" :key="item.id" :label="item.itemTypeName" :value="item.itemTypeId">
          </el-option>
        </el-select>
      </el-row>
      <el-row type="flex" align="middle">
        <upload-excel-component :on-success="handleUploadExcelSuccess" />
        <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
      </el-row>
      <div class="file-box">
        <span style="color: red">注意：时间格式按照“2022/10/10”填写</span>
      </div>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${index + 1}. ${item.fileName}` }}</div>
      </div>
      <div class="file-box" v-show="errorList">
        <span><span style="color: red">导入异常运单号：</span>{{ errorList }}</span>
      </div>
      <div slot="footer">
        <el-button size="small" @click="handleUploadExcelSubmit" :loading="btnLoading">确定导入
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看详情" :visible.sync="detailVisible" width="60%">
      <div class="box-card">
        <template v-if="detailData.orderInfo">
          <el-row style="margin-bottom: 14px;">
            <el-col :span="8">
              <strong>原订单ID：</strong>{{ detailData.orderInfo.id }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>原订单号：</strong>{{ detailData.orderInfo.amazonOrderId }}
            </el-col>
          </el-row>
          <div v-for="(item, index) in detailData.orderInfo.orderItems" :key="index + 'q'">
            <el-row class="custom-container">
              <el-col :span="4">
                <el-image style="width: 100%; height: 100%;" :src="item.imageUrl" :z-index="2200"
                  :preview-src-list="item.imageUrl.split(',')"></el-image>
              </el-col>
              <el-col :span="19" :offset="1" style="padding-top: 30px">
                <div class="inform flex">
                  <div class="title">商品简称：{{ item.title }}</div>
                </div>
                <div class="inform flex">
                  <div class="title">商品主SKU：{{ item.systemSku }}</div>
                </div>
                <div class="inform flex">
                  <div class="title">商品SKU别名：{{ item.sellerSKU }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>国家：</strong>{{ detailData.orderInfo.address.countryCode }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>退件条码：</strong>{{ detailData.returnBarcode }}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;">
            <el-col :span="8">
              <strong>退件单号(原转单号)：</strong>{{ detailData.oldConveyNumber }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>重派状态：</strong>{{ statusFont[detailData.status] }}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;">
            <el-col :span="8">
              <strong>重派时间：</strong>{{ detailData.reassignTime }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
          </el-row>
        </template>

        <template v-if="detailData.newOrderInfo">
          <el-divider></el-divider>
          <el-row style="margin-bottom: 14px;">
            <el-col :span="8">
              <strong>重派订单ID：</strong>{{ detailData.newOrderInfo.id }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>重派订单号：</strong>{{ detailData.newOrderInfo.amazonOrderId }}
            </el-col>
          </el-row>
          <div v-for="(item, index) in detailData.newOrderInfo.orderItems" :key="index + 'w'">
            <el-row class="custom-container">
              <el-col :span="4">
                <el-image style="width: 100%; height: 100%;" :src="item.imageUrl" :z-index="2200"
                  :preview-src-list="item.imageUrl.split(',')"></el-image>
              </el-col>
              <el-col :span="19" :offset="1" style="padding-top: 30px">
                <div class="inform flex">
                  <div class="title">商品简称：{{ item.title }}</div>
                </div>
                <div class="inform flex">
                  <div class="title">商品主SKU：{{ item.systemSku }}</div>
                </div>
                <div class="inform flex">
                  <div class="title">商品SKU别名：{{ item.sellerSKU }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>国家：</strong>{{ detailData.newOrderInfo.address.countryCode }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件人：</strong>{{ detailData.newOrderInfo.address.name }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>收件地址1：</strong>{{ detailData.newOrderInfo.address.addressLine1 }}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件地址2：</strong>{{ detailData.newOrderInfo.address.addressLine2 }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>收件地址3：</strong>{{ detailData.newOrderInfo.address.addressLine3 }}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件人城市：</strong>{{ detailData.newOrderInfo.address.city }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>收件人州：</strong>{{ detailData.newOrderInfo.address.stateOrRegion }}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件人电话：</strong>{{ detailData.newOrderInfo.address.phone }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <strong>收件人email：</strong>{{ detailData.newOrderInfo.buyerEmail }}
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="8">
              <strong>收件人邮编：</strong>{{ detailData.newOrderInfo.address.postalCode }}
            </el-col>
            <el-col :span="4">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
            <el-col :span="12">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 14px;margin-top: 14px;">
            <el-col :span="16">
              <strong>代收款金额：</strong>
              <el-input v-model.trim="detailData.newOrderInfo.money.amount"
                @change="changeAmount(detailData.newOrderInfo.money.amount)" type="number" :min="0"
                placeholder="请输入代收款金额" style="width:150px"></el-input>
              {{ detailData.newOrderInfo.money.currencyCode }}
            </el-col>
            <el-col :span="8">
              <div style="opacity: 0;">原订单ID：</div>
            </el-col>
          </el-row>
        </template>
        <div slot="footer" class="dialog-footer" style="text-align: right;" v-if="detailData.newOrderInfo">
          <el-button @click="detailVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 库存编辑
import buildbyoneself from './buildbyoneself/buildbyoneself'
// 新增产品库存
import Addinventory from './buildbyoneself/Addinventory'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxPost, Baseurl } from '../../api/api/api'
export default {
  name: 'COMparticulars',
  components: {
    buildbyoneself,
    Addinventory,
    UploadExcelComponent
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 5,
      size: 20,
      total: 0,
      ruleForm: {
        countryMark: '',
        exitStatus: '',
        status: '',
        timeType: '1',
        startTime: '',
        endTime: '',
        searchStr: '',
        channelType: '',
        purchaseModel: '',
			  inputList: ''
      },
      searchStrList:[],
      tableData: [],
      loading: false,
      countryList: [],
      statusType: ['info', '', 'success', 'danger'],
      statusFont: ['未处理', '重派中', '重派完成', '销毁'],
      dialogVisible: false,
      btnLoading: false,
      listFile: [],
      returnList: [],
      errorList: '',
      detailVisible: false,
      detailData: {},
      listLogistics: [],
      logistics: '',
      exportTime: [],
      ids: []
    }
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.search()
    this.getCountry()
    this.getLogisticsList()
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.returnList = []
      }
    }
  },
  methods: {
    destroyCodReturn(){
      this.$confirm('此操作将销毁选中数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(this.ids);
        ajaxPost(Baseurl + 'codReturnController/destroyCodReturn', { idList: this.ids }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '销毁成功!'
            });
            if (this.tableData.length == 1 && this.currentPage != 1) this.currentPage = this.currentPage - 1
            this.search()
          } else {
            this.$message({
              type: 'error',
              message: res.data.data
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消销毁'
        });
      });
    },
    handleSelectionChange(val) {
      this.ids = val.map(x => x.id)
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    handleExport() {
      if (!this.exportTime.length) {
        this.$message.error("请选择导出时间段！")
        return
      }
      window.open(`${Baseurl}codReturnController/codReturnExport?start=${this.exportTime[0]}&end=${this.exportTime[1]}`, 'target');
    },
    getLogisticsList() {
      const API = Baseurl + 'purchaseController/selectItemList'
      const paramsData = {
        itemCode: 'HYXUN0000007',
      }
      ajaxPost(API, paramsData).then((res) => {
        const { code, data } = res.data
        if (code === 200) {
          this.listLogistics = data
        }
      })
    },
    changeAmount(num) {
      if (Number(num) < 0) this.detailData.newOrderInfo.money.amount = 0
    },
    submitForm() {
      ajaxPost(
        Baseurl + 'moneyController/updateMoney',
        { id: this.detailData.newOrderInfo.money.id, amount: this.detailData.newOrderInfo.money.amount }
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("提交成功")
          this.detailVisible = false
          this.search()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    showDetail(data) {
      this.detailVisible = true
      this.detailData = data
    },
    handleUploadExcelSubmit() {
      if (!this.logistics) {
        this.$message.error("请选择渠道！")
        return
      }
      if (!this.returnList.length) {
        this.$message.error("请先导入文件！")
        return
      }
      this.btnLoading = true
      ajaxPost(
        Baseurl + 'codReturnController/importCodReturn/' + this.str.rid + '/' + this.logistics, this.returnList
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("成功导入" + res.data.data.successCount + "条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList.join(",")
          } else {
            this.dialogVisible = false
            this.listFile = []
            this.errorList = ''
          }
          this.search()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnLoading = false
      })
    },
    formatDate(numb, format) {
      const old = numb - 1;
      const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
      const time = new Date(1900, 0, old, 0, 0, t)
      const year = time.getFullYear();
      const month = time.getMonth() + 1;
      const date = time.getDate();
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
    },
    handleUploadExcelSuccess({ results, header, fileName }) {
      let returnList = results.map(item => ({
        returnBarcode: item.退件条码,
        oldConveyNumber: item.原运单号,
        orderChannelId: item.原订单号,
        exitStatus: item.退仓状态,
        noticeTime: this.formatDate(item.通知时间, '-'),
        destroyTime: this.formatDate(item.销毁时间, '-')
      }))
      let bool = false
      returnList.map(item => {
        if (item.destroyTime == "NaN-NaN-NaN" || item.noticeTime == "NaN-NaN-NaN") {
          bool = true
        }
      })
      if (bool == true) {
        this.$message.error("时间格式有误，请按照正确格式填写！")
        return
      }
      this.returnList.push(...returnList)
      this.listFile.push({ fileName })
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/COD%E9%80%80%E4%BB%B6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/COD%E9%80%80%E4%BB%B6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelDialogClose() {
      this.dialogVisible = false
      this.listFile = []
      this.errorList = ''
    },
    getCountry() {
      ajaxPost(
        Baseurl + 'logisticsConfigurationController/selectLogisticsCountryList'
      ).then((res) => {
        if (res.data.code === 200) {
          this.countryList = res.data.data
        }
      })
    },
    Edit(e) {
      this.$refs.buildbyoneself.init(e)
    },
    startTime(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 00:00:00'
      this.ruleForm.startTime = datetime
    },
    // 选择结束时间
    endTime(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 23:59:59'
      this.ruleForm.endTime = datetime
    },
    search2() {
      this.currentPage = 1
      this.search()
    },
    search() {
      this.loading = true
      // 库存列表
      var obj = {
        page: this.currentPage,
        size: this.size,
        ...this.ruleForm,
        channelType: this.ruleForm.channelType ? Number(this.ruleForm.channelType) : '',
        rid: this.str.rid
      }
      if (this.ruleForm.inputList != '') {
        this.$set(obj, 'searchStrList', this.ruleForm.inputList.split(' '))
      }
      ajaxPost(
        Baseurl + 'codReturnController/pageInfo',
        obj
      ).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        }
        this.loading = false
      })
    },
    del(val) {
      this.$confirm(
        '该操作会导致未入库的库存无法正常入库，无法对应，易导致货物丢失，请谨慎操作，是否继续删除？',
        '提示',
        {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
        }
      ).then(() => {
        var obj = {
          id: val.id,
        }
        ajaxPost(
          Baseurl + 'inventoryController/updateInventoryStatusById',
          obj
        ).then((res) => {
          if (res.data.code === 200) {
            this.search()
          } else {
            this.$message.error(res.data.data)
          }
        })
      })
    },
    resetFprm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.timeType = '1'
      this.currentPage = 1
      this.search()
    },
    Addinventory() {
      this.$refs.Addinventory.init()
    },
    handleSizeChange(val) {
      this.size = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .layout .layout-section ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #b71e1e;
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }

  .el-divider--horizontal {
    margin: 15px 0;
  }
}

.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.details_left {
  width: 30%;
  text-align: center;
}

.details_right {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.table-body {
  width: 100%;
  border: 1px solid #eee;
  overflow: hidden;
}

.table-batch {
  box-sizing: border-box;
  text-align: right;
  padding-right: 20px;
  width: 100%;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
  padding-left: 25px;
}

.information {
  width: 98%;
  overflow: hidden;
  margin-bottom: 50px;
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 300px;
  height: 300px;
}

.padding {
  padding: 5px 0;
}

.line-height {
  line-height: 35px;
}

.page {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 99;
}

.textlang {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.file-box {
  padding-top: 20px;
}
</style>
